import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React from 'react';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { DatePicker } from '@rexlabs/date-input';

function DefaultDatePicker(_ref) {
  var s = _ref.styles,
      rest = _objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/React.createElement(Box, s('container'), /*#__PURE__*/React.createElement(DatePicker, rest));
}

DefaultDatePicker.displayName = 'DefaultDatePicker';
export default styled(StyleSheet({
  container: {
    position: 'relative'
  }
}))(DefaultDatePicker);